import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { fmtD } from "./shared";
import { ReturnModal } from "./ReturnModal";

export function ToolHolders() {
    const [groups, setGroups] = useState(null);
    const [ret, setRet] = useState(null);
    const load = () => api.get("/tools/holders").then((r) => setGroups(r.data)).catch(() => setGroups([]));
    useEffect(() => { load(); }, []);
    if (!groups) return null;
    if (groups.length === 0) return <div className="bg-white border border-slate-200 p-10 text-center text-slate-400" data-testid="holders-empty">Nikdo nemá vydané nářadí.</div>;
    return (
        <div className="space-y-4" data-testid="tool-holders">
            {ret && <ReturnModal tool={ret} onClose={() => setRet(null)} onDone={() => { setRet(null); load(); }} />}
            {groups.map((g) => (
                <div key={`${g.holder.kind}-${g.holder.id}`} className="bg-white border border-slate-200" data-testid={`holder-${g.holder.id}`}>
                    <div className="px-4 py-3 border-b-2 border-slate-900 flex items-center justify-between"><div className="font-display font-bold uppercase tracking-wider text-sm">{g.holder.name}</div><div className="text-xs text-slate-500">{g.tools.length} ks · {g.holder.kind === "craftsman" ? "řemeslník" : "uživatel"}</div></div>
                    {g.tools.map((t) => (
                        <div key={t.id} className="flex items-center justify-between gap-3 px-4 py-2 border-b border-slate-100 min-h-[52px]">
                            <Link to={`/naradi/${t.id}`} className="min-w-0"><div className="font-medium text-slate-900 truncate">{t.name}</div><div className="text-xs text-slate-500 truncate">{t.inventory_no}{t.holder?.job_title ? ` · ${t.holder.job_title}` : ""} · od {fmtD(t.holder?.since)}</div></Link>
                            <button onClick={() => setRet(t)} data-testid={`holder-return-${t.id}`} className="min-h-[40px] px-3 text-xs uppercase tracking-wider font-semibold border border-slate-300 hover:bg-slate-100 rounded-sm shrink-0">Vrátit</button>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
